// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2sTss","errorLogs":"styles_errorLogs__1f8vq"};